module.exports = __webpack_public_path__ + "static/logo-hjarnkoll-e71a7bcf36f8e82bb4b84a1542b573ac.svg";